import React from "react";
import { Form } from "react-bootstrap";
import { SET_SIDEBAR_DATASET, useArsContext } from "../contexts";

/**
 * DatasetSelect provides a dropdown to select between available clinical datasets.
 *
 * @returns Dataset selection dropdown
 */
export const DatasetSelect = (): React.ReactNode => {
  const { state, dispatch } = useArsContext();
  const datasets = new Set<string>(state.variables.map((v) => v.dataset));
  return (
    <Form.Select
      id="ars-sidebar-dataset-select"
      size="sm"
      value={state.currentSidebar.dataset ?? ""}
      disabled={datasets.size === 0}
      onChange={(event) => {
        dispatch({ operation: SET_SIDEBAR_DATASET, dataset: event.currentTarget.value });
      }}
    >
      {!datasets.has(state.currentSidebar.dataset ?? "") && <option value="">-- Select --</option>}
      {Array.from(datasets).map((dataset) => (
        <option
          key={dataset}
          value={dataset}
        >
          {dataset}
        </option>
      ))}
    </Form.Select>
  );
};

DatasetSelect.displayName = "DatasetSelect";
